import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import User from "../../../domains/User/User";

interface UserSState {
  users: User[]
  areUsersLoading: boolean
  hasErrorGettingUsers: boolean
}

export const SLICE_NAME = "users";

const initialState: UserSState = {
  users: [],
  areUsersLoading: false,
  hasErrorGettingUsers: false,
};

export const usersSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    getUsers: state => {
      state.areUsersLoading = true;
    },
    getUsersSuccess: (state, action: PayloadAction<User[]>) => {
      state.areUsersLoading = false;

      state.users = action.payload;
    },
    getUsersError: state => {
      state.areUsersLoading = false;
      state.hasErrorGettingUsers = true;
    },
  },
});

export const { getUsers, getUsersError, getUsersSuccess } = usersSlice.actions;

export default usersSlice.reducer;
